import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {  SIDEBAR_TOGGLE_DIRECTIVES } from './sidebar.directive';

@NgModule({
  declarations: [
    SIDEBAR_TOGGLE_DIRECTIVES
  ],
  imports: [
    BrowserModule
  ],
  exports: [
    SIDEBAR_TOGGLE_DIRECTIVES
  ]
})
export class SidebarDirectiveModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/sidebar/sidebar.module.ts